export default __webpack_public_path__ + "static/media/7.a3f43606.mp4";